import {
  Box,
  Button,
  Container,
  Link,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";

import { useAppDispatch, useAppSelector } from "../../../../store/hooks";
import { toggleOnboarding } from "../../../../features/onboarding/onboarding.slice";
import { PricingPlans } from "../../../Subscriptions/partials/PricingPlans";
import { Logo } from "../../../../components";

import AmazonImage from "../../../../assets/promotion/amazon.png";
import AutoOpenImage from "../../../../assets/promotion/auto-open.png";
import AnalyzeImage from "../../../../assets/promotion/analyze.png";

const STEPS = [
  {
    image: AmazonImage,
    title: "Open any amazon product page",
    description: "Go to Amazon and click on any product you want to analyze.",
  },
  {
    image: AutoOpenImage,
    title: "SellerScout will open automatically",
    description:
      "Your extension will load instantly on the right side of the listing.",
  },
  {
    image: AnalyzeImage,
    title: "Start analyzing key data",
    description:
      "See ROI, fees, charts, IP alerts, competition, variations, and more.",
  },
];

export const ExtensionPromotionOnboardingRoute = () => {
  const dispatch = useAppDispatch();
  const { data: pricingPlans } = useAppSelector((state) => state.pricingPlans);
  const theme = useTheme();
  const mdDown = useMediaQuery(theme.breakpoints.down("md"));
  const smDown = useMediaQuery(theme.breakpoints.down("sm"));

  // const plans = pricingPlans.map((plan) =>
  //   plan.name.toLowerCase() === "free"
  //     ? {
  //         ...plan,
  //         onChange() {
  //           dispatch(toggleOnboarding(false));
  //         },
  //       }
  //     : plan,
  // );

  return (
    <Box sx={{ minHeight: "100vh", display: "flex", flexDirection: "column" }}>
      <Container maxWidth="lg" sx={{ py: 4 }}>
        <Box mb={{ xs: 4, md: 8 }}>
          <Logo height={23} />
        </Box>

        <Box display="flex" flexDirection="column" alignItems="center" gap={1}>
          <Typography
            textAlign="center"
            fontSize={{ xs: 24, md: 30 }}
            fontWeight={700}
            letterSpacing={"-0.75px"}
            lineHeight={{ md: "36px" }}
          >
            Welcome to SellerScout!
            <br />
            Your All-In-One Amazon Research Tool
          </Typography>
          <Typography
            sx={{
              color: "#45454C",
              fontWeight: 400,
              fontSize: "16px",
              lineHeight: "18.4px",
              textAlign: "center",
            }}
          >
            Every Amazon product page now comes with powerful new data
          </Typography>

          <Box
            display="flex"
            flexDirection={mdDown ? "column" : "row"}
            gap="60px"
            justifyContent="center"
            alignItems="flex-start"
            marginTop="67px"
          >
            {STEPS.map((step, index) => (
              <Stack
                alignItems="center"
                justifyContent="center"
                width={mdDown ? "100%" : "275px"}
              >
                <Box>
                  <img src={step.image} />
                </Box>
                <Typography
                  sx={{
                    fontWeight: 700,
                    fontSize: "22px",
                    lineHeight: "36px",
                    marginTop: "8px",
                  }}
                >
                  Step {index + 1}
                </Typography>
                <Box
                  border="0.5px solid #181D1F26"
                  borderRadius="8px"
                  padding="20px"
                  textAlign="center"
                  marginTop="16px"
                  minHeight={mdDown ? "unset" : "175px"}
                >
                  <Typography
                    sx={{
                      color: "#111111",
                      fontWeight: 600,
                      fontSize: "22px",
                      lineHeight: "28px",
                    }}
                  >
                    {step.title}
                  </Typography>
                  <Typography
                    sx={{
                      color: "#45454C",
                      fontWeight: 400,
                      fontSize: "16px",
                      lineHeight: "18.4px",
                      marginTop: "16px",
                    }}
                  >
                    {step.description}
                  </Typography>
                </Box>
              </Stack>
            ))}
          </Box>
          <Button
            variant="contained"
            sx={{
              height: "48px",
              marginTop: "44px",
              fontSize: "20px",
              paddingX: "24px",
            }}
            onClick={() =>
              window.open("https://www.amazon.com/dp/B0CRWRY5RM", "_blank")
            }
          >
            Analyze Your First Product
          </Button>
        </Box>
      </Container>

      <Box
        component="footer"
        sx={{
          minHeight: "72px",
          background: "#F6F6F6",
          mt: "auto", // Pushes the footer to the bottom
          display: "flex",
          alignItems: "center",
          paddingY: "16px",
        }}
      >
        <Container maxWidth="lg">
          <Box
            display="flex"
            flexDirection={mdDown ? "column" : "row"}
            justifyContent={mdDown ? "space-around" : "space-between"}
            alignItems="center"
            gap="16px"
          >
            <Typography
              sx={{ fontWeight: 400, fontSize: "15px", textAlign: "center" }}
            >
              SellerScout @ 2026, All rights reserved
            </Typography>

            <Stack
              alignItems="center"
              direction={smDown ? "column" : "row"}
              gap="16px"
            >
              <Link
                href="https://www.sellerscout.com/terms"
                sx={{ fontWeight: "700", fontSize: "15px", color: "#0E0E0F" }}
                underline="none"
              >
                Terms & Conditions
              </Link>
              <Link
                href="https://www.sellerscout.com/privacy"
                sx={{ fontWeight: "700", fontSize: "15px", color: "#0E0E0F" }}
                underline="none"
              >
                Privacy Policy
              </Link>
              <Link
                href="https://www.sellerscout.com/refund-cancellation"
                sx={{ fontWeight: "700", fontSize: "15px", color: "#0E0E0F" }}
                underline="none"
              >
                Refund & Cancellation
              </Link>
            </Stack>
          </Box>
        </Container>
      </Box>
    </Box>
  );
};
